import React from 'react';
import { assetUrl } from '~/helpers';

export type FooterProps = {
  className?: string;
  logoUrl?: string;
};

const Footer = ({ className = '', logoUrl }: FooterProps) => (
  <div
    className={`bg-black h-12 w-full flex items-center justify-center text-white ${className}`}
  >
    <div className='font-circular m-0 text-base'>Powered by</div>
    <img
      className='h-5 pl-6'
      src={logoUrl ?? assetUrl('/assets/images/logos/bj-logo-white.png')}
    />
  </div>
);

export default Footer;
